export default "__VITE_ASSET__Mzst6pTT__"